<template>
  
    <v-dialog scrollable max-width="400px" v-model="showDialog" class="ma-0">
      <template v-slot:activator="{ on }">
        <v-icon :disabled="disabled" :small="small" v-on="on">{{icon}}</v-icon>
      </template>

      <v-card>
        <v-card-title>{{ titulo }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="my-5">
            <h4 v-html="texto"></h4>
        </v-card-text>
        <v-card-actions>
          <v-btn big color="blue darken-1" text @click="clicked('NO')">NO</v-btn>
          <v-spacer></v-spacer>
          <v-btn big color="blue darken-1" text @click="clicked('SI')">SI</v-btn>
        </v-card-actions>
        <v-divider></v-divider>
      </v-card>
    </v-dialog>
  
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  props: {
    titulo: { type: String, default: "Confirmar" },
    texto: { type: String, default: "¿Esta seguro de continuar?" },
    icon: { type: String, default: "delete" },
    disabled: { type: Boolean, default: false },
    small: { type: Boolean, default: false }
  },
  data() {
    return {
      showDialog: false
    };
  },
  methods: {
    clicked(valor) {
      if (valor == "SI") {
        this.$emit("si");
      } else {
        this.$emit("no");
      }
      this.showDialog = false;
    }
  }
});
</script>